module.exports = __webpack_public_path__ + "img/seating_screen.f0007679.png";